import type { SimpleTask } from 'Automations/nodeDefinitions/conductor'
import { readDataFromTask } from '../readDataFromTask'

/**
 * Every task the editor writes pins a version, so the fallback is only for a
 * definition that was hand-edited or written by something older.
 */
export const executorVersion = (task: SimpleTask): number => {
  const version = readDataFromTask({
    source: task.inputParameters,
    path: 'taskExecutorConfiguration.version'
  })

  return typeof version === 'number' ? version : 1
}
